import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', () => {
  const showChat = ref(false)
  const showCompanySettings = ref(false)
  const chatFocusInput = ref(false)
  const isTyping = ref(false)
  const expandedProjects = ref<string[]>(['project-1'])

  const toggleChat = () => {
    showChat.value = !showChat.value
  }

  const openChatWithFocus = () => {
    showChat.value = true
    chatFocusInput.value = true
  }

  const closeChatFocus = () => {
    chatFocusInput.value = false
  }

  const toggleCompanySettings = () => {
    showCompanySettings.value = !showCompanySettings.value
  }

  const toggleProject = (projectId: string) => {
    const index = expandedProjects.value.indexOf(projectId)
    if (index > -1) {
      expandedProjects.value.splice(index, 1)
    } else {
      expandedProjects.value.push(projectId)
    }
  }

  const setTyping = (typing: boolean) => {
    isTyping.value = typing
  }

  return {
    showChat,
    showCompanySettings,
    chatFocusInput,
    isTyping,
    expandedProjects,
    toggleChat,
    openChatWithFocus,
    closeChatFocus,
    toggleCompanySettings,
    toggleProject,
    setTyping
  }
})